app.$state.modules.filter(m => m != 'Site').forEach(m => {
    require(`@modulesPages/${m}/Resources/assets/js/app`)
})

require('@modulesPages/Site/Resources/assets/js/app')
